
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.847 27a2.681 2.681 0 01-2.434-1.523h-4.85a2.7 2.7 0 11-4.708-2.622l-3.706-5.192a2.767 2.767 0 01-.442.036 2.692 2.692 0 110-5.384 2.775 2.775 0 01.529.051l3.573-5.282a2.705 2.705 0 114.9-2.216h4.559a2.71 2.71 0 015.287.83 2.665 2.665 0 01-.485 1.536l3.63 5.147a2.76 2.76 0 01.593-.065 2.691 2.691 0 11-.682 5.3l-3.383 5.422A2.684 2.684 0 0119.847 27zM15 17.19l-2.81 5.379a2.756 2.756 0 01.518.923h4.558a2.847 2.847 0 01.532-.939zm4.848 4.434a2.751 2.751 0 01.82.125l3.325-5.327a2.013 2.013 0 01-.214-.422h-7.141l2.94 5.635c.092-.007.178-.01.269-.01zM6.221 16a2.251 2.251 0 01-.352.624L9.491 21.7a2.82 2.82 0 01.638-.076c.092 0 .187 0 .288.014L13.358 16zM19.6 8.38l-2.94 5.634h7.118a3.151 3.151 0 01.266-.5L20.4 8.335a2.779 2.779 0 01-.548.056 2.465 2.465 0 01-.252-.011zM9.409 8.295l-3.491 5.162a2.458 2.458 0 01.3.557h7.115L10.4 8.379a3.201 3.201 0 01-.268.011 2.781 2.781 0 01-.723-.095zm3.155-1.4a2.809 2.809 0 01-.386.574L15 12.866l2.814-5.383a2.881 2.881 0 01-.4-.587h-4.851z","fill":"#222"}})])
          )
        }
      }
    